import React from 'react';
import { FiCheck, FiChevronDown } from 'react-icons/fi';

export default function SectionCard({ title, icon: Icon, isExpanded, isComplete, onClick, children }) {
  return (
    <div
      className={`glass rounded-2xl transition-all duration-200 ${
        isExpanded ? 'col-span-1 sm:col-span-2' : ''
      }`}
    >
      <button
        type="button"
        onClick={onClick}
        className="w-full flex items-center gap-3 p-4 text-left"
      >
        <div className={`w-10 h-10 rounded-xl flex items-center justify-center transition ${
          isComplete ? 'bg-green-500/20' : 'bg-white/10'
        }`}>
          {isComplete ? (
            <FiCheck className="w-5 h-5 text-green-400" />
          ) : (
            <Icon className="w-5 h-5 text-white/60" />
          )}
        </div>
        <span className="flex-1 text-white font-medium">{title}</span>
        <FiChevronDown className={`w-5 h-5 text-white/40 transition-transform duration-200 ${
          isExpanded ? 'rotate-180' : ''
        }`} />
      </button>

      {isExpanded && (
        <div className="px-4 pb-5 pt-1">
          {children}
        </div>
      )}
    </div>
  );
}
